import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Task\CreateTaskController::__invoke
* @see app/Http/Controllers/Task/CreateTaskController.php
* @route '/api/task'
*/
const CreateTaskController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateTaskController.url(options),
    method: 'post',
})

CreateTaskController.definition = {
    methods: ["post"],
    url: '/api/task',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Task\CreateTaskController::__invoke
* @see app/Http/Controllers/Task/CreateTaskController.php
* @route '/api/task'
*/
CreateTaskController.url = (options?: RouteQueryOptions) => {
    return CreateTaskController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Task\CreateTaskController::__invoke
* @see app/Http/Controllers/Task/CreateTaskController.php
* @route '/api/task'
*/
CreateTaskController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateTaskController.url(options),
    method: 'post',
})

export default CreateTaskController